<crowdctrl-unauthenticated-page
  [pageTitle]="pageTitle"
  [showFooter]="false"
  defaultHref="/about/how-it-works"
>
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle><strong>CrowdCTRL Manager</strong></h1>
      <p crowdctrlUnauthIntroLead>
        Where <strong>team leads</strong> and administrators shape how the service behaves before
        anyone walks into the room.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section">
      <p class="about-project__text">
        They maintain the roster of tenant users, organise them into user groups, and author
        workspace definitions: reusable blueprints that describe queues, optional forms and display
        boards, and the rules that govern access, service order, and limits. Think of
        <strong>CrowdCTRL Manager</strong> as the place you design the machine;
        <strong>CrowdCTRL Service</strong> is where you run it.
      </p>
    </section>

    <a
      href="/about/how-it-works"
      class="about-project__back-link"
      (click)="unauthNav.forward($event, '/about/how-it-works')"
      >Back to How it all works</a
    >
  </div>
</crowdctrl-unauthenticated-page>
